import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { monthlyEquivalent } from "@/lib/frequency"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Converts an expense amount + frequency into its monthly equivalent.
 * Used for "On Hold" budget reservations.
 * Delegates to {@link monthlyEquivalent} so all frequency math lives in one place.
 */
export function getMonthlyEquivalent(amount: number, frequency?: string | null): number {
  return monthlyEquivalent(amount, frequency);
}
